/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DataFindJobPositionLevelQueryResponse } from './DataFindJobPositionLevelQueryResponse';
import {
    DataFindJobPositionLevelQueryResponseFromJSON,
    DataFindJobPositionLevelQueryResponseFromJSONTyped,
    DataFindJobPositionLevelQueryResponseToJSON,
} from './DataFindJobPositionLevelQueryResponse';

/**
 * 
 * @export
 * @interface FindJobPositionQueryResponse
 */
export interface FindJobPositionQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof FindJobPositionQueryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindJobPositionQueryResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FindJobPositionQueryResponse
     */
    description: string;
    /**
     * 
     * @type {DataFindJobPositionLevelQueryResponse}
     * @memberof FindJobPositionQueryResponse
     */
    jobPositionLevels?: DataFindJobPositionLevelQueryResponse;
}

/**
 * Check if a given object implements the FindJobPositionQueryResponse interface.
 */
export function instanceOfFindJobPositionQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function FindJobPositionQueryResponseFromJSON(json: any): FindJobPositionQueryResponse {
    return FindJobPositionQueryResponseFromJSONTyped(json, false);
}

export function FindJobPositionQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindJobPositionQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'jobPositionLevels': !exists(json, 'jobPositionLevels') ? undefined : DataFindJobPositionLevelQueryResponseFromJSON(json['jobPositionLevels']),
    };
}

export function FindJobPositionQueryResponseToJSON(value?: FindJobPositionQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'jobPositionLevels': DataFindJobPositionLevelQueryResponseToJSON(value.jobPositionLevels),
    };
}

